// ui/mui/core/src/Divider.tsx
import { Divider as MUIDivider, DividerProps } from '@mui/material';
export const Divider = (props: DividerProps) => (
  <MUIDivider data-testid="divider" {...props} />
);
